import React, { useDeferredValue, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Spin, Table, Typography, message } from "antd";
import { ExcludedAPI } from "../../API/ExcludedApi";
import {
  COMPLETED_COLUMNS_HEAD,
  REJECTED_COLUMNS_HEAD,
  STYLES,
} from "./ExcludedUtils";
import TableEmptyContent from "../../Components/TableEmptyContent/TableEmptyContent";

export default function Exculded() {
  const [messageApi, contextHolder] = message.useMessage();
  const [spinning, setSpinning] = useState(false);
  const [defualtReject, setDefualtReject] = useState([]);
  const [defualtComplete, setDefualtComplete] = useState([]);
  const [rejectedSelectedRowsArray, setRejectedSelectedRowsArray] = useState(
    [],
  );
  const [rMoveList, setRMoveList] = useState([]);
  const [completedSelectedRowsArray, setCompletedSelectedRowsArray] = useState(
    [],
  );
  const [cMoveList, setCMoveList] = useState([]);
  const [completedList, setCompletedList] = useState([]);
  const [rejectedList, setRejectedList] = useState([]);
  const [rejectIput, setRejectInput] = useState("");
  const [completeIput, setCompleteIput] = useState("");

  const deferredreject = useDeferredValue(rejectIput);
  useEffect(() => {
    rejectSerachFun();
  }, [deferredreject]);

  const deferrecomplete = useDeferredValue(completeIput);
  useEffect(() => {
    completeSerachFun();
  }, [deferrecomplete]);

  async function getAllList() {
    const queryParams = {
      params: {
        flight_model: localStorage.getItem("flight_model"),
      },
    };
    setSpinning(true);
    await ExcludedAPI.rejectedCompletedList(queryParams)
      .then((res) => {
        if (res.data?.status === true) {
          const rarr = res.data?.rejected.map((ele, ind) => ({
            ...ele,
            key: ind + 1,
          }));
          const carr = res.data?.completed.map((ele, ind) => ({
            ...ele,
            key: ind + 1,
          }));
          setCompletedList(carr);
          setRejectedList(rarr);
          setDefualtReject(rarr);
          setDefualtComplete(carr);
        } else {
          messageToast("error", res.data.message);
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      })
      .finally(() => {
        setSpinning(false);
      });
  }

  const messageToast = (type, message) => {
    messageApi.open({
      type: type,
      content: message,
      duration: 6,
    });
  };

  useEffect(() => {
    getAllList();
  }, []);

  const removeRejectsFun = () => {
    if (rMoveList.length > 0) {
      const bodydata = {
        flight_model: localStorage.getItem("flight_model"),
        rejected: rMoveList,
        completed: [],
      };
      removeSpecs(bodydata);
      setRejectedSelectedRowsArray([]);
      setRMoveList({});
    } else {
      messageToast("warning", "Please Select Any one of the spec");
    }
  };
  const removeCompletedFun = () => {
    if (cMoveList.length > 0) {
      const bodydata = {
        flight_model: localStorage.getItem("flight_model"),
        rejected: [],
        completed: cMoveList,
      };
      removeSpecs(bodydata);
      setCompletedSelectedRowsArray([]);
      setCMoveList({});
    } else {
      messageToast("warning", "Please Select Any one of the spec");
    }
  };

  async function removeSpecs(bodydata) {
    setSpinning(true);
    await ExcludedAPI.removeInList(bodydata)
      .then((res) => {
        if (res.data?.status === true) {
          getAllList();
        } else {
          messageToast("error", res.data.message);
          setSpinning(false);
          if (res.data?.reload === true) {
            setTimeout(() => {
              window.location.reload();
            }, "2000");
          }
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
        setSpinning(false);
      });
  }

  function rejectSerachFun() {
    setRejectedSelectedRowsArray([]);
    setRMoveList({});
    if (rejectIput.trim() !== "") {
      let arr = [...defualtReject];
      let filterArr = arr.filter((ele) => {
        if (
          rejectIput.trim() !== "" &&
          ele.spec_concat
            .toLowerCase()
            .includes(rejectIput.trim().toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      setRejectedList(filterArr);
    } else {
      setRejectedList([...defualtReject]);
    }
  }

  function completeSerachFun() {
    setCompletedSelectedRowsArray([]);
    setCMoveList({});
    if (completeIput.trim() !== "") {
      let arr = [...defualtComplete];
      let filterArr = arr.filter((ele) => {
        if (
          completeIput.trim() !== "" &&
          ele.spec_concat
            .toLowerCase()
            .includes(completeIput.trim().toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      setCompletedList(filterArr);
    } else {
      setCompletedList([...defualtComplete]);
    }
  }

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | Excluded</title>
      </Helmet>

      <Spin spinning={spinning}>
        <HeaderTab currrentTab="excluded" />

        <div className="config_split_div">
          <div className="box_wraper_div">
            <Typography style={{ ...STYLES.tableTitle }}>
              Rejected Items
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Button
                type="primary"
                style={{ marginTop: "5px" }}
                onClick={removeRejectsFun}
              >
                Remove Selected
              </Button>
              <div style={{ ...STYLES.searchBard }}>
                <input
                  className="searc_input"
                  value={rejectIput}
                  onChange={(e) => setRejectInput(e.target.value)}
                />
                <SearchOutlined
                  className="search_btn"
                  style={{
                    color: "#737373",
                    fontSize: "18px",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              </div>
            </div>

            <Table
              rowKey="key"
              columns={REJECTED_COLUMNS_HEAD}
              dataSource={rejectedList}
              pagination={{
                pageSize: 4,
                responsive: true,
                hideOnSinglePage: true,
              }}
              rowSelection={{
                type: "checkbox",
                selectedRowKeys: rejectedSelectedRowsArray,
                onChange: (selectedRowKeys, selectedRows) => {
                  setRejectedSelectedRowsArray(selectedRowKeys);
                  const arr = selectedRows.map((ele) => {
                    return ele.spec_concat;
                  });
                  setRMoveList(arr);
                },
              }}
              style={{ marginTop: "20px" }}
              className="antdTable"
              locale={{
                emptyText: <TableEmptyContent />,
              }}
            />
          </div>
          <div className="box_wraper_div">
            <Typography style={{ ...STYLES.tableTitle }}>
              Escalation Completed Items
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Button
                type="primary"
                style={{ marginTop: "5px" }}
                onClick={removeCompletedFun}
              >
                Remove Selected
              </Button>
              <div style={{ ...STYLES.searchBard }}>
                <input
                  className="searc_input"
                  value={completeIput}
                  onChange={(e) => setCompleteIput(e.target.value)}
                />
                <SearchOutlined
                  className="search_btn"
                  style={{
                    color: "#737373",
                    fontSize: "18px",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              </div>
            </div>

            <Table
              rowKey="key"
              columns={COMPLETED_COLUMNS_HEAD}
              dataSource={completedList}
              pagination={{
                pageSize: 4,
                responsive: true,
                hideOnSinglePage: true,
              }}
              rowSelection={{
                type: "checkbox",
                selectedRowKeys: completedSelectedRowsArray,
                onChange: (selectedRowKeys, selectedRows) => {
                  setCompletedSelectedRowsArray(selectedRowKeys);
                  const arr = selectedRows.map((ele) => {
                    return ele.spec_concat;
                  });
                  setCMoveList(arr);
                },
              }}
              style={{ marginTop: "20px" }}
              className="antdTable"
              locale={{
                emptyText: <TableEmptyContent />,
              }}
            />
          </div>
        </div>
      </Spin>

      {contextHolder}
    </div>
  );
}
